import { useGetPeriodTypes } from 'queries';

export const useGetOptions = () => {
  const { data, isError } = useGetPeriodTypes();

  if (isError) {
    return [];
  }

  return (
    data?.map((item) => {
      return {
        value: item.code,
        label: item.name
      };
    }) ?? []
  );
};
